export function errorGuard(store, router) {
  // Catch errors
  router.onError(error => {
    store.dispatch('nprogress/done');
    console.error(error.message);
  });
}
